/**
 * @file State management
 * @author
 */
import Vue from 'vue';
import Vuex from 'vuex';
import { stat } from 'fs';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        passIDs: [
            "T223626421",
            "T123136119",
            "P120140679",
            "K220583879",
            "A123992468",
            "F227785546", //20200407 insert
            // temp
            "A123456789",
            "C220830661",
            "A123664076", // Director
            // 20211215 add
            "Q123934147",
            "T123136199",
            "J222825093",
        ],
        // URL query parameters
        query: {
            System: null,
            Ticket: null,
            qrcode: null
        },
        // Logged-in user info
        userData: {
            Name: null,
            Phone: null,
            IDNumber: null,
        },
        query: {
            qrcode: null,
            System: null,
            Ticket: null,
        },
        Hash: null,
        masterAllData: [], // Main warehouse all data
        masterFindData: [], // Main warehouse displayed data
        masterFilterData: [],

        slaveAllData: [], // Sub warehouse all data
        slaveFindData: [], // Sub warehouse displayed data
        slaveFilterData: [], // Filtered data

        signAllData: [],
        signFindData: [],
        signFilterData: [],

        // Inspection order data
        listingAllData: [],
        listingFindData: [],
        listingFilterData: [],
        // Inspection repair request data
        callRepairAllData: [],
        callRepairFindData: [],
        callRepairFilterData: [],
        // Dispatch order data
        tasktingAllData: [],
        tasktingFindData: [],
        tasktingFilterData: [],
        // History list
        historyAllData: [],
        historyFindData: [],
        historyFilterData: [],
        // Venue list
        leaseAllData: [],
        leaseFindData: [],
        leaseFilterData: [],
        // Venue history list
        leaseHistoryAllData: [],
        leaseHistoryFindData: [],
        leaseHistoryFilterData: [],

        isShowPaging: false,
        dialogType: null,
        isShowDialog: false,
        storageSelectData: [], // Selected material data in storage system
        signedData: null, // Designated signing data
        upDateSign: false, // Whether to update signing page data while keeping current page
        nowPageIndex: 1, // Current pagination parameter
        isUpdateSortNum: false, // Whether to update pagination sequence number
        fontSize: null, // Record how many px equals 1rem
        clearSearchValue: false, // Whether to clear search box content
        inspectionTabIndex: 0, // Inspection page tab index

        remitData: {
            from: null, // Page source
            beginDate: null,
            endDate: null,
            ids: new Map(),
        },

        // Calendar page parameters
        calendarData: {
            index: 0,
            nowData: null
        },

        // nicky
        // inspection => maintain order
        InspectionData: null,
    },

    mutations: {
        addData(state, obj) {
            state[obj.key] = obj.value
        },
        updateStorageSelectData(state) {
            state.storageSelectData.forEach(item => {
                item.stockoutnNum = 0;
            });
        },
        // For main warehouse edit operations - restore default values on cancel
        editorMasterData(state, data) {
            data.forEach((item, i) => {
                //Limit Spec Location Remark
                state.storageSelectData[i].Limit = item.Limit;
                state.storageSelectData[i].Spec = item.Spec;
                state.storageSelectData[i].Location = item.Location;
                state.storageSelectData[i].Remark = item.Remark;
            })
        },
        signCodeSort(state, value) {
            state.signFilterData.sort((a, b) => {
                let nowEle = a.OrderCode.substr(3);
                let nextEle = b.OrderCode.substr(3);
                if (value) {
                    // Ascending
                    return nowEle - nextEle
                } else {
                    // Descending
                    return nextEle - nowEle
                }
            })
            state.isUpdateSortNum = true;
            state.signFindData = state.signFilterData.slice(0, 12)
        },
        signTimeSort(state, value) {
            state.signFilterData.sort((a, b) => {
                let nowEle = new Date(a.CreatedTime).getTime();
                let nextEle = new Date(b.CreatedTime).getTime();
                if (value) {
                    // Ascending
                    return nowEle - nextEle;
                } else {
                    // Descending
                    return nextEle - nowEle;
                }
            })
            state.isUpdateSortNum = true;
            state.signFindData = state.signFilterData.slice(0, 12)
        },
        signUserSort(state, value) {
            // Ascending
            state.signFilterData.sort((s1, s2) => {
                let x1 = s1.CreatedUser.toUpperCase();
                let x2 = s2.CreatedUser.toUpperCase();
                if (x1 < x2) {
                    return -1;
                }
                if (x1 > x2) {
                    return 1;
                }
                return 0;
            })
            if (!value) {
                // Descending
                state.signFilterData.reverse()
            }
            state.isUpdateSortNum = true;//!!!
            state.signFindData = state.signFilterData.slice(0, 12)
        },
        editStockoutNum(state, obj) {
            state.storageSelectData[obj.index][obj.key] = obj.value
        },
        SET_IS_SHOW_DIALOG(state, value) {
            if (value != undefined) {
                state.isShowDialog = value;
            } else {
                state.isShowDialog = !state.isShowDialog
            }
        },
        SET_DIALOG_TYPE(state, value) {
            state.dialogType = value
        },
        // Sort by sequence number
        sortByCode(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                let s1 = a.Code, s2 = b.Code;
                a = s1.split('-').join();
                b = s2.split('-').join();
                // a = a.Code.toUpperCase();
                // b = b.Code.toUpperCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)

        },
        // Sort by name
        sortByName(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Name
                b = b.Name
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        //
        sortByQuantity(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Quantity
                b = b.Quantity
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        //
        sortByLimit(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Limit
                b = b.Limit
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        //
        sortByLocation(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Location.toUpperCase();
                b = b.Location.toUpperCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        //
        sortByOrderCode(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.OrderCode.substr(2)
                b = b.OrderCode.substr(2)
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)

        },
        //
        sortByArea(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Area
                b = b.Area
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        //
        sortByPlace(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Place
                b = b.Place
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        // Sort by expected completion date
        sortByEndTime(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.EndTime && new Date(a.EndTime).getTime();
                b = b.EndTime && new Date(b.EndTime).getTime();
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by completion date
        sortByCompleteDate(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.CompleteDate && new Date(a.CompleteDate).getTime();
                b = b.CompleteDate && new Date(b.CompleteDate).getTime();
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by department
        sortByContactDept(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.ContactDept;
                b = b.ContactDept;
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        // Sort by floor
        sortByFloor(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Floor;
                b = b.Floor;
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by source
        sortBySource(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Source;
                b = b.Source;
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
            //console.log(state[str + 'FindData'], '@@@@@@@@@')
        },
        // Sort by emergency level
        sortByEmergencyLevel(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.EmergencyLevel;
                b = b.EmergencyLevel;
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by repair item
        sortByWork(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.Work;
                b = b.Work;
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        // Sort by start date
        sortByBeginTime(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.AcBeginTime && new Date(a.AcBeginTime).getTime();
                b = b.AcBeginTime && new Date(b.AcBeginTime).getTime();
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by end date
        sortByEndTime(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.AcEndTime && new Date(a.AcEndTime).getTime();
                b = b.AcEndTime && new Date(b.AcEndTime).getTime();
                return a - b;
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12);
        },
        // Sort by site
        sortBySite(state, str) {
            state[str + 'FilterData'].sort((a, b) => {
                a = a.LendingSite;
                b = b.LendingSite;
                return a.localeCompare(b, 'zh-CN');
            })
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        // Reverse sort
        reverseList(state, str) {
            state[str + 'FilterData'].reverse();
            state.isUpdateSortNum = true;
            state[str + 'FindData'] = state[str + 'FilterData'].slice(0, 12)
        },
        editRemitData(state, obj) {
            state.remitData.type = obj.type;
            state.remitData.beginDate = obj.beginDate || null;
            state.remitData.endDate = obj.endDate || null;
            state.remitData.ids = obj.ids || null;
        },

        // nicky
        SetLendingSiteOrderListStatus(state, obj) {

            // let order = state.leaseFindData.find(item => item.id === obj.ID);
            let index = state.leaseFindData.findIndex(item => item.ID === obj.id);
            state.leaseFindData[index].StatusValue = obj.statusValue;
            state.leaseFindData[index].Status = obj.status;
            state.leaseFindData[index].Charge = obj.charge;
            console.log(obj.id, index, state.leaseFindData[index]);
        },
        RemoveLendingReviewPageAttached(state, obj) {
            let index = state.signedData.Attached.findIndex(a => a.ID === obj.ID);
            state.signedData.Attached.splice(index, 1);
        },

        SetInspectionData(state, obj) {
            state.InspectionData = obj;
        },
        ClearInspectionDate(state) {
            state.InspectionData = null;
        },
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js